import { AuditLog } from "@common/types/auditLog";

export enum ChatChangeComponent {
    TITLE = "title",
    STATUS = "status",
    ASSIGNEE = "assignee",
    DUE_DATE = "dueDate",
    PRIORITY = "priority",
    ESTIMATED_TIME = "estimatedTime",
    ENTITIES = "entities",
    FINANCIAL_DOCUMENTS = "financial_documents",
    BLOCKED_BY_TASKS = "blockedByTasks",
    BLOCKING_TASKS = "blockingTasks",
    RELATED_TASKS = "relatedTasks",
    CLOSE_STAGE = "closeStage",
    CLOSE = "close",
}

export function defineChatChangeComponent(
    log: AuditLog,
): ChatChangeComponent | undefined {
    if (log.diff.find((d) => d.field === "title")) {
        return ChatChangeComponent.TITLE;
    }
    if (log.diff.find((d) => d.field === "status")) {
        return ChatChangeComponent.STATUS;
    }
    if (log.diff.find((d) => d.field === "assigneeId")) {
        return ChatChangeComponent.ASSIGNEE;
    }
    if (log.diff.find((d) => d.field === "dueDate")) {
        return ChatChangeComponent.DUE_DATE;
    }
    if (log.diff.find((d) => d.field === "priority")) {
        return ChatChangeComponent.PRIORITY;
    }
    if (log.diff.some((d) => d.field === "estimatedTime")) {
        return ChatChangeComponent.ESTIMATED_TIME;
    }
    if (log.diff.find((d) => d.field === "entities")) {
        return ChatChangeComponent.ENTITIES;
    }
    if (log.diff.find((d) => d.field === "financialDocuments")) {
        return ChatChangeComponent.FINANCIAL_DOCUMENTS;
    }
    if (log.diff.find((d) => d.field === "blockedByTasks")) {
        return ChatChangeComponent.BLOCKED_BY_TASKS;
    }
    if (log.diff.find((d) => d.field === "blockingTasks")) {
        return ChatChangeComponent.BLOCKING_TASKS;
    }
    if (log.diff.find((d) => d.field === "relatedTasks")) {
        return ChatChangeComponent.RELATED_TASKS;
    }
    if (log.diff.some((d) => d.field === "closeStageId")) {
        return ChatChangeComponent.CLOSE_STAGE;
    }
    if (log.diff.some((d) => d.field === "closeId")) {
        return ChatChangeComponent.CLOSE;
    }
    return undefined;
}
